// External Imports
import { FieldErrors, FormProvider } from 'react-hook-form'
import { SaveBar } from '@shopify/app-bridge-react'

// Custom Hooks
import useScrollToError from '@/hooks/useScrollToError'

// Form Imports
import { FormSchema } from './schema'
import { useSettingsForm } from './hooks'

// Component Imports
import { DateFormatSettings } from '@/components/settings/DateFormatSettings'
import { ValidationSettings } from '@/components/settings/ValidationSettings'

import { Settings } from '@/common/types'

interface SettingsFormProps {
  settings: Settings
}

const SettingsForm = ({ settings }: SettingsFormProps) => {
  const { submit, isPending, form } = useSettingsForm(settings)

  const {
    formState: { isDirty },
    handleSubmit,
    reset,
  } = form

  const [setCanFocus] = useScrollToError(form.formState.errors)

  const onFormSubmitValid = (data: FormSchema) => {
    submit(data)
  }

  const onFormSubmitInvalid = (errors: FieldErrors<FormSchema>) => {
    setCanFocus(true)
    console.log(errors)
  }

  return (
    <>
      <SaveBar id="settings-save-bar" open={isDirty}>
        <button
          variant="primary"
          onClick={() => handleSubmit(onFormSubmitValid, onFormSubmitInvalid)()}
          disabled={isPending}
          loading={isPending ? '' : undefined}
        ></button>
        <button onClick={() => reset()} disabled={isPending}></button>
      </SaveBar>
      <FormProvider {...form}>
        <DateFormatSettings />
        <ValidationSettings />
      </FormProvider>
    </>
  )
}

export { SettingsForm }
